import React, { useState } from 'react';
import { FaWallet } from 'react-icons/fa';
import { Eye } from 'lucide-react';
import { Button, ConfirmationDialog } from 'components/Elements';

export const Wallet = ({ wallet }) => {
  const [canViewId, setCanViewId] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleRequestAccess = () => {
    alert(
      'Under development, the root user access is not available at the moment.'
    );
    setDialogOpen(false);
  };

  return (
    <div className="bg-white/10 backdrop-blur-md p-4 rounded-2xl shadow-md border border-white/10 text-white flex justify-between items-center transition hover:scale-[1.02]">
      <div className="flex items-center gap-4">
        {/* Flag + Wallet icon */}
        <div className="bg-white/10 p-1 rounded-full flex items-center justify-center relative w-14 h-14">
          <img
            className="w-8 h-8 border-2 border-white rounded-full shadow-sm object-cover"
            src={`https://flagcdn.com/h20/${wallet.flagCode.toLowerCase()}.png`}
            alt={wallet.currencyCode}
            title={wallet.currencyCode}
          />
          <div className="absolute -bottom-1 -right-1 bg-white/10 border border-white rounded-full p-1 w-5 h-5 flex items-center justify-center">
            <FaWallet className="text-white" size={24} />
          </div>
        </div>

        {/* Wallet ID + Currency Name */}
        <div>
          <div className="flex items-center gap-2">
            <div
              className={`text-[10px] uppercase tracking-widest px-2 py-0.5 bg-white/10 rounded-full font-mono 
              }`}
            >
              {canViewId ? 'WR24W003TRS345' : 'WR24W003TRS345'.slice(0, 6)} ...
              
            </div>
            <ConfirmationDialog
              isOpen={dialogOpen}
              onOpenChange={setDialogOpen}
              icon="info"
              title="Root Access Required"
              body="To proceed with this action, you need root access. Would you like to request for access from super user?"
              triggerButton={
                <button>
                  <Eye className="text-white/60 hover:text-white" size={16} />
                </button>
              }
              confirmButton={
                <Button
                  type="button"
                  variant="glass"
                  onClick={handleRequestAccess}
                >
                  Request Access
                </Button>
              }
            />
          </div>
          <div className="text-base font-semibold capitalize">
            {wallet.currencyName}
          </div>
        </div>
      </div>

      <div className="text-lg font-bold text-white">
        {wallet.currencyCode} {parseFloat(wallet.balance).toLocaleString()}
      </div>
    </div>
  );
};
